// src/pages/Dashboard/components/FilterBar.jsx

import React, { memo } from "react";
import { FolderKanban, CalendarDays, GitCompareArrows } from "lucide-react";

import "./FilterBar.css";

function FilterBar({
  projects,
  projectId,
  onProjectChange,
  availableMonths,
  monthYearValue,
  onMonthYearChange,
  comparisonMode,
  onComparisonModeChange,
}) {
  return (
    <div className="sd-filterbar">
      {/* =========================================
      HEADER
      ========================================= */}
      <div className="sd-filterbar-header">
        <div>
          <h3>Dashboard Filters</h3>
          <p>
            Filter reports by project, month, or compare multiple project
            performances.
          </p>
        </div>

        <div className="sd-filterbar-badge">
          {comparisonMode ? "Comparison Mode" : "Standard Mode"}
        </div>
      </div>

      {/* =========================================
      FILTER GRID
      ========================================= */}
      <div className="sd-filterbar-grid">
        {/* PROJECT */}
        <div className="sd-filter-card">
          <label>
            <FolderKanban size={16} />
            Project
          </label>

          <select
            value={projectId}
            onChange={(e) => onProjectChange(e.target.value)}
          >
            <option value="ALL">All Projects</option>

            {projects.map((p) => (
              <option key={p._id} value={p._id}>
                {p.projectName}
              </option>
            ))}
          </select>
        </div>

        {/* MONTH */}
        <div className="sd-filter-card">
          <label>
            <CalendarDays size={16} />
            Month
          </label>

          <select
            value={monthYearValue}
            onChange={(e) => onMonthYearChange(e.target.value)}
          >
            <option value="ALL">All Months</option>

            {availableMonths.map((m) => (
              <option
                key={`${m.month}-${m.year}`}
                value={`${m.month}-${m.year}`}
              >
                {m.label}
              </option>
            ))}
          </select>
        </div>

        {/* MODE */}
        <div className="sd-filter-card">
          <label>
            <GitCompareArrows size={16} />
            Dashboard Mode
          </label>

          <select
            value={comparisonMode ? "COMPARE" : "NORMAL"}
            onChange={(e) =>
              onComparisonModeChange(e.target.value === "COMPARE")
            }
          >
            <option value="NORMAL">Single Project</option>

            <option value="COMPARE">Compare Projects</option>
          </select>
        </div>
      </div>
    </div>
  );
}

export default memo(FilterBar);
